module.exports = __webpack_public_path__ + "img/mystic_staff.685c4981.png";